define( function() {
	"use strict";

	return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/pnum.js
// module id = kdUt
// module chunks = 0 1